import { Component, OnInit, HostListener } from '@angular/core';
import { HudComponent } from '../hud/hud.component';
import { FooterComponent } from '../footer/footer.component';
@Component({
    selector: 'app-thanks',
    templateUrl: './thanks.component.html',
    styleUrls: ['./thanks.component.css'],
    imports: [HudComponent, FooterComponent]
})
export class ThanksComponent implements OnInit {
  showCharacters = false;

  ngOnInit() {
    if (window.innerWidth > 1660) {
      this.showCharacters = true;
    }
  }

  @HostListener("window:resize", [])
  onResize() {
    const width = window.innerWidth;
    this.showCharacters = width > 1660;
  }
}
